module.exports = __webpack_public_path__ + "img/xqtx-app.98059a7b.png";